import {
  AlertState,
  AlertSeverity,
  IAlertAction,
} from "../actions/types/alertTypes";

const initialState: AlertState = {
  show: false,
  title: "",
  severity: AlertSeverity.info,
};

export const alertReducer = (
  state = initialState,
  action: IAlertAction<any>
): AlertState => {
  switch (action.type) {
    case "HIDE_ALERT":
      return {
        ...state,
        show: false,
      };

    case "SHOW_ALERT":
      return {
        title: action.payload.title,
        severity: action.payload.severity,
        show: true,
      };

    default:
      return state;
  }
};
